import { render, staticRenderFns } from "./Manage_modules.vue?vue&type=template&id=7f46b7a7&"
import script from "./Manage_modules.vue?vue&type=script&lang=js&"
export * from "./Manage_modules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports